<script>
import emailjs from "emailjs-com";

import { Icon } from "@iconify/vue";

export default {
  components: { Icon },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: "",
      },
      emailSent: false,
      isLoading: false,
      sendError: false,
    };
  },
  methods: {
    sendEmail() {
      this.isLoading = true; // Start loading
      const templateParams = {
        from_name: this.formData.name,
        email_id: this.formData.email,
        message: this.formData.message,
      };

      emailjs
        .send(
          "service_pltbxss",
          "template_08m6j4a",
          templateParams,
          "eYhzkfzvSFELv43Cy"
        )
        .then((response) => {
          console.log("SUCCESS!", response.status, response.text);
          this.emailSent = true;
          this.sendError = false;
        })
        .catch((error) => {
          console.log("FAILED...", error);
          this.sendError = true;
        })
        .finally(() => {
          this.isLoading = false; // Stop loading regardless of success or error
          this.resetForm();
        });
    },
    resetForm() {
      this.formData = { name: "", email: "", message: "" };
    },
  },
};
</script>

<template>
  <div class="w-full">
    <div class="leading-loose p-3 md:p-7 rounded-xl text-left">
      <form @submit.prevent="sendEmail" class="font-general-regular space-y-7">
        <input
          class="w-full px-5 py-3 border border-gray-300 dark:border-primary-dark border-opacity-50 text-primary-dark dark:text-white font-normal bg-[#f7f8fc] dark:bg-ternary-dark rounded-md shadow-sm text-base placeholder:text-ternary-dark dark:placeholder:text-ternary-light"
          id="name"
          name="name"
          placeholder="Full Name"
          aria-label="name"
          type="text"
          v-model="formData.name"
          required
        />

        <input
          class="w-full px-5 py-3 border border-gray-300 dark:border-primary-dark border-opacity-50 text-primary-dark dark:text-white font-normal bg-[#f7f8fc] dark:bg-ternary-dark rounded-md shadow-sm text-base placeholder:text-ternary-dark dark:placeholder:text-ternary-light"
          id="email"
          name="email"
          placeholder="Email"
          aria-label="email"
          type="text"
          v-model="formData.email"
          required
        />

        <textarea
          class="w-full px-5 py-2 border border-gray-300 dark:border-primary-dark border-opacity-50 text-primary-dark dark:text-secondary-light bg-[#f7f8fc] dark:bg-ternary-dark rounded-md shadow-sm text-base placeholder:text-ternary-dark dark:placeholder:text-ternary-light"
          id="message"
          name="message"
          aria-label="message"
          placeholder="Message"
          v-model="formData.message"
          cols="14"
          rows="6"
        ></textarea>

        <div>
          <button
            type="submit"
            class="flex cursor-pointer items-center align-middle justify-center rounded-lg border border-gray-300 dark:border-primary-dark border-opacity-50 shadow-md bg-[#f7f8fc] dark:bg-ternary-dark px-4 py-2 text-base font-medium text-ternary-dark dark:text-white transition hover:bg-opacity-90"
          >
            <span class="mr-3">Send Message</span>
            <Icon
              v-if="isLoading"
              icon="line-md:loading-twotone-loop"
              class="w-6 h-6"
            />
            <Icon v-else icon="mingcute:send-line" class="w-6 h-6" />
          </button>

          <p
            v-if="emailSent"
            class="bg-white dark:bg-ternary-dark p-4 mt-5 font-semibold text-green-500 rounded-sm"
          >
            Message sent successfully!
          </p>

          <p
            v-if="sendError"
            class="bg-white dark:bg-ternary-dark p-4 mt-5 font-semibold text-red-500 rounded-sm"
          >
            Message sending failed!
          </p>
        </div>

        <!-- Success Message -->
      </form>
    </div>
  </div>
</template>

<style scoped></style>
